var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeContent"},[_c('FrontendNav'),_vm._v(" "),_c('FrontendHomeTop'),_vm._v(" "),_c('FrontendHomeFeatured',{attrs:{"books":_vm.featured}}),_vm._v(" "),_c('FrontendHomeCategories',{attrs:{"catList":_vm.categories}}),_vm._v(" "),_c('FrontendFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00f71b08","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontend/home/home.vue
// module id = null
// module chunks = 